<template>
    <rkm-layout-body title="Geração / Lançamento de procedimento">
        <template v-slot:actions>
            <rkm-button
                @click="$refs.ModalGeracao.open()"
                authorize="store-apac-procedimento"
                color="primary"
            >
                Gerar
            </rkm-button>

            <rkm-button
                @click="$router.push({ name: 'apac-procedimento-create' })"
                authorize="store-apac-procedimento"
                color="primary"
            >
                Cadastrar procedimento
            </rkm-button>

            <rkm-button
                @click="$refs.ModalExclusao.open()"
                authorize="destroyAutomaticos-apac-procedimento"
                color="danger"
            >
                Excluir APAC
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List ref="List" />
        </rkm-layout-content>

        <ModalGeracao
            ref="ModalGeracao"
            @save="$refs.List.refresh()"
        />

        <ModalExclusao
            ref="ModalExclusao"
            @save="$refs.List.refresh()"
        />
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/apac/procedimento/List'
import ModalGeracao from '@/components/apac/procedimento/components/geracao/Modal'
import ModalExclusao from '@/components/apac/procedimento/components/exclusao/Modal'

export default {
    components: {
        List,
        ModalGeracao,
        ModalExclusao,
    },
}
</script>